module.exports = __webpack_public_path__ + "img/user-create.272a03b5.svg";